import tp from 'shared-tokens/utils/tokens/typography';
import spacings from 'shared-tokens/utils/tokens/spacings';
import createBreakpoint from 'shared-tokens/utils/breakpoints';

const brpS = createBreakpoint('s');

export const mainCls = 'usrregistration';

const dottedSeparator = {
  content: '""',
  position: 'absolute',
  left: 0,
  width: '100%',
  height: 1,
  backgroundImage: 'linear-gradient(90deg, #96a1b0 20%, rgba(255, 255, 255, 0) 0)',
  backgroundPosition: '0',
  backgroundSize: '4px 1px',
  backgroundRepeat: 'repeat-x',
};

export default {
  [mainCls]: {
    maxWidth: '540px',
  },
  [`${mainCls}__mycasa__else`]: {
    'position': 'relative',
    'lineHeight': '66px',
    '&::before': {
      ...dottedSeparator,
      top: '50%',
    },
  },
  [`${mainCls}__mycasa__else--txt`]: {
    display: 'block',
    position: 'relative',
    zIndex: '1',
    margin: '0 auto',
    width: '70px',
    color: '#505a65',
    background: '#f0f2f5',
  },
  [`${mainCls}__mycasa__input`]: {
    'margin': `0 0 ${spacings.s}px`,
    '&:last-of-type': {
      marginBottom: spacings.m,
    },
  },
  [`${mainCls}__mycasa__registrationerror`]: {
    color: '#ff8000',
    lineHeight: '20px',
  },
  [`${mainCls}__more`]: {
    'position': 'relative',
    'lineHeight': '69px',
    '&::before': {
      ...dottedSeparator,
      top: 0,
    },
  },
  [`${mainCls}__infos`]: {
    textAlign: 'left',

  },
  [`${mainCls}__form__privacy--a`]: {
    textDecoration: 'underline',
  },
  [`${mainCls}__checkbox`]: {
    textAlign: 'left',
  },
  [`${mainCls}__form__btn`]: {
    width: '240px',
  },
  [`${mainCls}__form__wrap_inpt`]: {
    display: 'flex',
  },
  [`${mainCls}__form__inpt_disabled`]: {
    border: 'none',
    background: 'transparent',
    width: '100%',
  },
};
